import { ValidationController, ValidationControllerFactory, ValidateResult, ValidationRules, validateTrigger, ControllerValidateResult } from 'aurelia-validation';
import { Layout } from 'Common/Layout/Layout';
import { NewInstance } from 'aurelia-dependency-injection';
import { ObjectHelper } from './ObjectHelper';
import { StringHelper } from './StringHelper';
import { autoinject } from 'aurelia-framework';
import { I18N } from 'aurelia-i18n';
import { ValidateCreditCardNumberResult } from 'Common/Code/Model/Models';

// Validation on items in an array - https://discourse.aurelia.io/t/validation-on-items-in-an-array-foreach/834/2

@autoinject
export class ValidationHelper {

    protected i18n: I18N = null;
    private _controllerFactory: ValidationControllerFactory = null;
    private _validationController: ValidationController = null;

    constructor(controllerFactory: ValidationControllerFactory, i18n: I18N) {
        this._controllerFactory = controllerFactory;
        this.i18n = i18n;
    }

    public async ValidateOld(entityName: string, entityData: Object, validationRules: Array<any>): Promise<boolean> {

        // create and init validation controller
        this._validationController = this._controllerFactory.createForCurrentScope();
        this._validationController.validateTrigger = validateTrigger.manual;

        // reset validation errors and remove errors from form
        await this._validationController.reset();
        await this.resetErrors(entityName);

        // execute validation 
        await this._validationController.validate({
            object: entityData,
            rules: validationRules
        })


        // check if exists any errors (is not valid)
        if (this._validationController.errors.length > 0) {
            await this.showHeadErrors(entityName, this._validationController.errors);
            return false; // false - is not valid
        }
        return true;  // true - is valid
    }

    public async Validate(entityName: string, entityData: Object, validationRules: Array<any>, validationRulesItemGrids?: any): Promise<Array<ValidateResult>> {

        let result: Array<ValidateResult> = [];
        // create and init validation controller
        this._validationController = this._controllerFactory.createForCurrentScope();
        this._validationController.validateTrigger = validateTrigger.manual;

        // reset validation errors and remove errors from form
        await this._validationController.reset();
        await this.resetErrors(entityName);

        // execute validation 
        await this._validationController.validate({
            object: entityData,
            rules: validationRules
        })

        if (this._validationController.errors.length > 0) {
            await this.showHeadErrors(entityName, this._validationController.errors);
        }
        //console.log(111, 'Validate Errors', result);

        if (ObjectHelper.ObjectIs(validationRulesItemGrids)) {
            const itemGridNames: Array<any> = Object.getOwnPropertyNames(validationRulesItemGrids);
            if (ObjectHelper.ArrayIs(itemGridNames)) {
                for (let i1 = 0; i1 < itemGridNames.length; i1++) {
                    if (ObjectHelper.ArrayIs(entityData[itemGridNames[i1]])) {
                        for (let i2 = 0; i2 < entityData[itemGridNames[i1]].length; i2++) {
                            const row: any = entityData[itemGridNames[i1]][i2];
                            if (row.Deleted == true) {
                            }
                            else {
                                const err1: ControllerValidateResult = await this._validationController.validate({
                                    object: row,
                                    rules: validationRulesItemGrids[itemGridNames[i1]]
                                })
                                if (!err1.valid && ObjectHelper.ArrayIs(err1.results)) {
                                    this.showRowErrors(itemGridNames[i1], err1.results)
                                }
                            }
                        }
                    }
                }
            }
        }
        if (ObjectHelper.ArrayIs(this._validationController.errors)) {
            for (let i1 = 0; i1 < this._validationController.errors.length; i1++) {
                const item: ValidateResult = this._validationController.errors[i1];
                if (!item.valid) {
                    result.push(item);
                }
            }
        }
        if (ObjectHelper.ArrayIs(result)) {
            console.log(112, 'Validate Errors', result);
        }
        return result;
    }

    public async createRules(entityName: string, entitySchema: Object, currentLayout: Layout, isRowEntity: boolean, ignoreLayout?: boolean): Promise<Array<any>> {
        //console.log(2222, entityName, entitySchema);
        let locale: string = this.i18n.getLocale().toLowerCase().substring(0, 2);
        // 
        await this.customRulesInitialization();

        // array declaration for validation rules
        let validationRules: Array<any> = [];

        //
        let stringLayout = JSON.stringify(currentLayout ? currentLayout.EditForm : {});

        // filter schema array
        let visibleColumns = entitySchema['Columns'].filter((item) => item.hasOwnProperty('IsVisibleOnForm') && item.IsVisibleOnForm == true && (item.IsReadOnly == null || item.IsReadOnly == undefined || item.IsReadOnly == false));
        if (isRowEntity) {
            visibleColumns = entitySchema['Columns'].filter((item) => item.hasOwnProperty('IsVisibleOnItemGrid') && item.IsVisibleOnItemGrid == true && (item.IsReadOnly == null || item.IsReadOnly == undefined || item.IsReadOnly == false));
        }

        // each all items from array
        for (let index in visibleColumns) {

            // get item by index from filtered array
            let column = visibleColumns[index];
            const columnTypeId: number = column['Type_FK'] * 1;

            // check if current items is in the currentLayout
            if ((ObjectHelper.IsNotNullAndUndefined(ignoreLayout) && ignoreLayout == true) || stringLayout.indexOf('"FieldName":"' + column['ColumnName'] + '"') >= 0) {

                switch (columnTypeId) {
                    case 2: // Integer
                    case 17:	 // BigInt
                    case 3: // Float
                    case 4: // Money
                    case 5:	 // String
                    case 14:	 // Guid
                    case 26:	 // IconSelect
                    case 6:	 // Text
                    case 22:	 // TextSimple
                    case 9:	 // MultiEnumeration
                    case 8:	 // Enumeration
                    case 10:	 // Entity
                    case 13:	 // Signature
                    case 21:	 // EntityEnumeration
                    case 27:	 // MultiStateBox
                    case 7:	 // Date
                    case 11:	 // Time
                    case 12:	 // DateTime
                    case 18:	 // Geography
                    case 40:	 // ProcessBar
                    case 34: // EmailAddress
                    case 35: // PhoneNumber
                    case 36: // WebUrl
                    case 37: //DateWithoutYear
                    case 39: //WikiText
                    case 40: //ProcessBar
                    case 41: //Range
                    case 42: //RuianAddress
                    case 44: //EmailAddressSuggestion
                    case 45: //Html
                    case 46: //DateWithoutDay
                    case 48: //CreditCardNumber

                        {
                            // chceck if item has nullable property and if nullable property is set on false
                            if (column.hasOwnProperty('Nullable') && column.Nullable == 0) {
                                // create new require rule for this item
                                let newRules = ValidationRules.ensure(column['ColumnName'])
                                    .displayName(column['LocalizationString'])
                                    .required()
                                    .withMessage((isRowEntity ? (entitySchema['EntityNameTitle'] + ' - ') : '') + this.i18n.tr('Validation.FieldIsRequired', { 'fieldName': column['LocalizationString'] }))
                                    .rules;

                                // merger rules array with new rules array
                                validationRules = validationRules.concat(newRules);
                            }

                        } break;
                }

                let newRules: Array<any> = this.ColumnTypeToValidationRules(column);
                if (newRules.length > 0) {
                    validationRules = validationRules.concat(newRules);
                }

                if (ObjectHelper.ObjectIs(column['ConfigJson']) && ObjectHelper.ArrayIs(column['ConfigJson']['FieldValidation'])) {
                    for (let i1 = 0; i1 < column['ConfigJson']['FieldValidation'].length; i1++) {
                        const rule: any = column['ConfigJson']['FieldValidation'][i1];

                        let notValidMess: string = '';
                        if (StringHelper.StringIs(rule.NotValidMess)) {
                            notValidMess = rule.NotValidMess;
                        }
                        if (StringHelper.StringIs(rule['NotValidMess_' + locale])) {
                            notValidMess = rule['NotValidMess_' + locale];
                        }
                        let validationRulesItem = ValidationRules.ensure(column['ColumnName']).displayName(column['LocalizationString']).satisfiesRule(rule.Rule, rule.Args);
                        if (StringHelper.StringIs(notValidMess)) {
                            validationRules = validationRules.concat(validationRulesItem.withMessage((isRowEntity ? (entitySchema['EntityNameTitle'] + ' - ') : '') + notValidMess).rules);
                        }
                        else {
                            validationRules = validationRules.concat(validationRulesItem.withMessage((isRowEntity ? (entitySchema['EntityNameTitle'] + ' - ') : '') + column['LocalizationString'] + ' - ' + this.i18n.tr('Validation.' + rule.Rule)).rules);
                        }
                    }
                }
            }
        }

        // return all validation rules
        return validationRules;
    }

    private ColumnTypeToValidationRules(col: any): Array<any> {
        const columnTypeId: number = col['Type_FK'] * 1;
        const stringMaxLength: number = col['StringMaxLength'] * 1;
        let newRules: Array<any> = []

        if (columnTypeId <= 0) {
            return newRules;
        }

        switch (columnTypeId) {
            case 2: // Integer
            case 17:	 // BigInt
                {
                    newRules = ValidationRules.ensure(col['ColumnName']).displayName(col['LocalizationString'])
                        .satisfiesRule('integer').rules;
                } break;
            case 3: // Float
            case 4: // Money
                {
                    newRules = ValidationRules.ensure(col['ColumnName']).displayName(col['LocalizationString'])
                        .satisfiesRule('decimal').rules;
                } break;
            case 5:	 // String
            case 14:	 // Guid
            case 26:	 // IconSelect
                {
                    if (stringMaxLength > 0) {
                        newRules = ValidationRules.ensure(col['ColumnName']).displayName(col['LocalizationString'])
                            .maxLength(stringMaxLength)
                            .withMessage(this.i18n.tr('Validation.StringMaxLength', { 'stringMaxLength': stringMaxLength }))
                            .rules;
                    }
                } break;
            case 1: // Bit
            case 6:	 // Text
            case 15:	 // XML
            case 19:	 // Varbinary
            case 20:	 // Image
            case 22:	 // TextSimple
            case 23:	 // WidgetHtml
            case 24:	 // SystemChart
            case 25:	 // UserChart
            case 28:	 // JSON
            case 29:	 // DashboardTable
            case 9:	 // MultiEnumeration
            case 16:	 // DateCheckBox
            case 13:	 // Signature
                {
                    // No validation
                } break;
            case 8:	 // Enumeration
            case 10:	 // Entity
            case 40:	 // ProcessBar
                {
                    newRules = ValidationRules.ensure(col['ColumnName']).displayName(col['LocalizationString'])
                        .satisfiesRule('positiveInteger').rules;
                } break;
            case 27:	 // MultiStateBox
                {
                    newRules = ValidationRules.ensure(col['ColumnName']).displayName(col['LocalizationString'])
                        .satisfiesRule('integer').rules;
                } break;
            case 21:	 // EntityEnumeration
                {
                    newRules = ValidationRules.ensure(col['ColumnName']).displayName(col['LocalizationString'])
                        .satisfiesRule('integer').rules;
                } break;
            case 7:	 // Date
                {
                    newRules = ValidationRules.ensure(col['ColumnName']).displayName(col['LocalizationString'])
                        .satisfiesRule('date').rules;
                } break;
            case 11:	 // Time
                {
                    newRules = ValidationRules.ensure(col['ColumnName']).displayName(col['LocalizationString'])
                        .satisfiesRule('time').rules;
                } break;
            case 12:	 // DateTime
                {
                    newRules = ValidationRules.ensure(col['ColumnName']).displayName(col['LocalizationString'])
                        .satisfiesRule('dateTime').rules;
                } break;

            case 18:	 // Geography
                {
                    newRules = ValidationRules.ensure(col['ColumnName'] + '_Long').displayName(col['LocalizationString'])
                        .satisfiesRule('decimal').rules;
                    newRules = ValidationRules.ensure(col['ColumnName'] + '_Lat').displayName(col['LocalizationString'])
                        .satisfiesRule('decimal').rules;

                } break;
            case 34: // EmailAddress 
                {
                    newRules = ValidationRules.ensure((col['ColumnName'])).displayName(col['LocalizationString']).satisfiesRule('email').rules;
                    break;
                }
            case 35: break; // PhoneNumber
            case 36: // WebUrl
                {
                    newRules = ValidationRules.ensure(col['ColumnName']).displayName(col['LocalizationString']).matches(/^(?!www\.[^.]+\.?$)(?:https?:\/\/)?[\w.-]+(?:\.[\w.-]+)+[\w._~:/?#[\\\]@!$&'()*+%,;=.-]+$/).rules;
                    //console.log(newRules);
                    break;
                }
            case 37: //DateWithoutYear
            case 39: //WikiText
            case 40: //ProcessBar
            case 41: //Range
            case 42: //RuianAddress
            case 44: //EmailAddressSuggestion
            case 45: //Html
            case 46: //DateWithoutDay
                {
                    // No validation
                } break;
            case 48: //CreditCardNumber
                {
                    newRules = ValidationRules.ensure((col['ColumnName'])).displayName(col['LocalizationString']).satisfiesRule('credit-card-number').rules;
                    //console.log(newRules);
                    break;
                }

        }
        return newRules;
    }

    public showRowErrors(entityName: string, errors: Array<ValidateResult>) {
        if (ObjectHelper.ArrayIs(errors)) {
            for (let i1 = 0; i1 < errors.length; i1++) {
                const item: ValidateResult = errors[i1];
                if (!item.valid) {
                    let elem = ($(`td.row-container-item[data-validation-name="ValidationMessageRow.${entityName}.${item.object.Id}.${item.propertyName}"]`) as any);
                    //console.log(111, elem, elem.find('.form-control:first'));
                    elem.addClass('has-error');
                }
            }
        }
    }

    public async showHeadErrors(entityName: string, errors: Array<ValidateResult>) {
        if (ObjectHelper.ArrayIs(errors)) {
            for (let i1 = 0; i1 < errors.length; i1++) {
                const item: ValidateResult = errors[i1];
                let propertyName = item.propertyName.toString();
                if (StringHelper.EndsWith(propertyName, '_Lat')) {
                    propertyName = propertyName.replace('_Lat', '');
                }
                if (StringHelper.EndsWith(propertyName, '_Long')) {
                    propertyName = propertyName.replace('_Long', '');
                }

                // add error class for control and show validation message
                let elem = ($(`div.form-group[data-validation-name="ValidationMessage.${entityName}.${propertyName}"]`) as any);
                elem.find('label:first').addClass('has-error').closest('div.form-group')
                    .find('.validation-message:first').addClass('has-error').text(item.message).show().closest('div.form-group')
                    .find('.form-control:first').addClass('has-error');
            }
        }
    }

    public async resetErrors(entityName: string) {

        // remove all error class and hide error message
        ($(`div.form-group[data-validation-name]`) as any)
            .find('label:first').removeClass('has-error').closest('div.form-group')
            .find('.validation-message:first').removeClass('has-error').text('').hide().closest('div.form-group')
            .find('.form-control:first').removeClass('has-error');

        ($(`td.row-container-item[data-validation-name]`) as any)
            .removeClass('has-error');
    }

    private async customRulesInitialization() {
        ValidationRules.customRule(
            'TextRegExp',
            (value, obj, args) => {
                if (ObjectHelper.ArrayIs(args) && StringHelper.StringIs(args[0].RegExp)) {
                    if (ObjectHelper.IsNullOrUndefined(value) || StringHelper.IsNullOrEmpty(value)) {
                        return true;
                    }
                    let regEx = new RegExp(args[0].RegExp);
                    return regEx.test(value);
                    //console.log(111111, value, obj, args[0].RegExp, regEx.test(value));
                }
                return true;
            }
        )
        ValidationRules.customRule(
            'DateTimeLessThan',
            (value, obj, args) => {
                if (ObjectHelper.ArrayIs(args)) {
                    const conf1: any = args[0];
                    if (ObjectHelper.IsNullOrUndefined(value) || StringHelper.IsNullOrEmpty(value)
                        || ObjectHelper.IsNullOrUndefined(obj[conf1.Field]) || StringHelper.IsNullOrEmpty(obj[conf1.Field])) {
                        return true;
                    }
                    return moment(value).isBefore(moment(obj[conf1.Field]))
                }
                return false;
            },
            this.i18n.tr('Validation.DateTimeLessThan')
        )
        ValidationRules.customRule(
            'DateTimeGreaterThan',
            (value, obj, args) => {
                if (ObjectHelper.ArrayIs(args)) {
                    const conf1: any = args[0];
                    if (ObjectHelper.IsNullOrUndefined(value) || StringHelper.IsNullOrEmpty(value)
                        || ObjectHelper.IsNullOrUndefined(obj[conf1.Field]) || StringHelper.IsNullOrEmpty(obj[conf1.Field])) {
                        return true;
                    }
                    return moment(value).isAfter(moment(obj[conf1.Field]))
                }
                return false;
            },
            this.i18n.tr('Validation.DateTimeGreaterThan')
        )
        ValidationRules.customRule(
            'integer',
            (value, obj) => {
                return ObjectHelper.IsNullOrUndefined(value) || StringHelper.IsNullOrEmpty(value) || (!Number.isNaN(Number(value)) && Number.isInteger(Number(value)) && Math.abs(value) < 2147483648)
            },
            this.i18n.tr('Validation.TypeInteger')
        )
        ValidationRules.customRule(
            'positiveInteger',
            (value, obj) => {
                return ObjectHelper.IsNullOrUndefined(value) || StringHelper.IsNullOrEmpty(value) || (!Number.isNaN(Number(value)) && Number.isInteger(Number(value)) && Number.parseInt(value) > 0 && Math.abs(value) < 2147483648)
            },
            this.i18n.tr('Validation.TypePostiveInteger')
        )
        ValidationRules.customRule(
            'decimal',
            (value, obj) => {
                return ObjectHelper.IsNullOrUndefined(value) || StringHelper.IsNullOrEmpty(value) || (!Number.isNaN(Number(value)) && Math.abs(value) < 100000000000000)
            },
            this.i18n.tr('Validation.TypeDecimal')
        )
        ValidationRules.customRule(
            'date',
            (value, obj) => {
                return ObjectHelper.IsNullOrUndefined(value) || StringHelper.IsNullOrEmpty(value) || (moment(value) != null && moment(value).isValid())
            },
            this.i18n.tr('Validation.TypeDate')
        )
        ValidationRules.customRule(
            'dateTime',
            (value, obj) => {
                return ObjectHelper.IsNullOrUndefined(value) || StringHelper.IsNullOrEmpty(value) || (moment(value) != null && moment(value).isValid())
            },
            this.i18n.tr('Validation.TypeDateTime')
        )
        ValidationRules.customRule(
            'time',
            (value, obj) => {
                let locale: string = this.i18n.getLocale().toLowerCase().substring(0, 2);
                return ObjectHelper.IsNullOrUndefined(value) || StringHelper.IsNullOrEmpty(value) || (moment(value, 'LT', locale, false) != null && moment(value, 'LT', locale, false).isValid())
            },
            this.i18n.tr('Validation.TypeTime')
        )
        ValidationRules.customRule(
            'email',
            (value, obj) => {
                //let locale: string = this.i18n.getLocale().toLowerCase().substring(0, 2);
                let mail: string = value;
                if (mail == null || mail == '') {
                    return true;
                }
                mail = mail.toLowerCase();
                let regEx = new RegExp(',| ', 'g');
                let splitEmails = mail.split(regEx).filter(x => x != '');
                regEx = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
                let emailsResults = splitEmails.map(email => ObjectHelper.IsNotNullAndUndefined(email.match(regEx))).filter(x => x == false);
                if (ObjectHelper.IsNotNullAndUndefinedAndEmpty(emailsResults) && emailsResults.length > 0) {
                    return false;
                } else {
                    return true;
                }
            },
            this.i18n.tr('Validation.BadEmailAddress')
        )
        ValidationRules.customRule(
            'credit-card-number',
            (value, obj) => {
                //let locale: string = this.i18n.getLocale().toLowerCase().substring(0, 2);
                let number: string = value;
                if (number == null || number == '') {
                    return true;
                }
                const res: ValidateCreditCardNumberResult = StringHelper.ValidateCreditCardNumber(number);
                console.log(8888, 'credit-card-number', res)
                return res.Valid;
            },
            this.i18n.tr('Validation.BadCreditCardNumber')
        )        
    }
}